import i18next from "i18next";
import type { AppLanguageType } from "@noa/i18n";
import type { AppConfig, QuickPrompt } from "../app-config";

/**
 * Picks the current-language quick prompts out of an already-loaded `AppConfig`.
 * Auth/fetch-agnostic — each app supplies its own `appConfigs` source (network
 * fetch on web, a bundled asset on mobile).
 */
export function useQuickPrompts(appConfigs: AppConfig | undefined, isLoading: boolean) {
  const prompts: QuickPrompt[] = appConfigs?.quickPrompts[i18next.language as AppLanguageType] ?? [];
  return { prompts, isLoading };
}
